import * as React from "react";
import { TreeView } from "@progress/kendo-react-treeview";
import { useState } from "react";
import { useEffect } from "react";

//data soruce format
export const SBATreeList = ({ data, setdata,checkBox, expandIcon, parentValueField,textField, ChildrenValueField, afterExpand, afterCheck }) => {
    const [Treedata, setTreeData] = useState(data);
    useEffect(()=>{setTreeData(data)},[data])
    const onCheckChange = (event) => {
        const DataCopy = [...Treedata];
        if (event.item.items) {
            const updatedIndex = Treedata.findIndex(item => item[parentValueField] === event.item[parentValueField]);
            DataCopy[updatedIndex] = { ...event.item, "checked": !event.item.checked, items: event.item.items.map(it => ({ ...it, checked: !event.item.checked })) }
        }
        else {
            const updatedIndex = Treedata.findIndex(item => item[parentValueField] === event.item[parentValueField]);
            const updatedParent = Treedata.find(item => item[parentValueField] === event.item[parentValueField]);
            const updatedChildernIndex = updatedParent.items.findIndex(item => item[ChildrenValueField] === event.item[ChildrenValueField]);
            updatedParent.items[updatedChildernIndex] = { ...event.item, checked: !event.item.checked };
            DataCopy[updatedIndex] = {...updatedParent,checked:false};
        };
        setdata(DataCopy);
        setTreeData(DataCopy);
        if (afterCheck) {
            afterCheck(DataCopy);
        }
    };
    const onExpandChange = (event) => {
        const updatedIndex = Treedata.findIndex(item => item[parentValueField] === event.item[parentValueField])
        const DataCopy = [...Treedata];
        DataCopy[updatedIndex] = { ...event.item, expanded: !event.item.expanded }
        setTreeData(DataCopy);
        setdata(DataCopy);
        if (afterExpand) {
            afterExpand(DataCopy);
        }
    }
    return (
        <div>
            <TreeView data={Treedata} checkboxes={checkBox} onCheckChange={onCheckChange} expandIcons={expandIcon} onExpandChange={onExpandChange} textField={textField} />
        </div>
    );
};
